import React from "react";
import { ImageSlideShowContainer } from "./styles";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import ModalComponent from "../Modals";
import { useMediaQuery, useTheme } from "@mui/material";
import { IGallery } from "../../store/services/invitations/dto/invitations.dto";

const ImageSlideShow = ({
	open,
	selectedInvitationGallery,
	initialSlideShowImage = 0,
	handleCloseModal
}: {
	open: boolean;
	selectedInvitationGallery: IGallery[];
	initialSlideShowImage: number;
	handleCloseModal: () => void;
}) => {
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));

	return (
		<ModalComponent open={open} handleCloseModal={handleCloseModal} width={isSmallerScreen ? "95%" : "700px"}>
			<ImageSlideShowContainer>
				<ImageGallery
					items={[...(selectedInvitationGallery || [])]
						.filter(item => item.image_url)
						.map(image => ({
							original: image.image_url
						}))}
					showFullscreenButton={false}
					startIndex={initialSlideShowImage}
				/>
			</ImageSlideShowContainer>
		</ModalComponent>
	);
};

export default ImageSlideShow;
